var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7246 29.8398V47.2731H30.1579L26.5222 43.6374H16.3603V33.4756L12.7246 29.8398Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7531 56.8914L54.5358 51.6015V56.3642H3.63575V48.8201H7.27147V45.9115H3.63575V33.8228H7.27147V30.9142H3.63575V19.2799H7.27147V16.3713H3.63575V6.20948L32.6125 35.0226V29.8962L3.10857 0.537752C2.85431 0.28138 2.52945 0.106537 2.17543 0.0355143C1.82141 -0.0355089 1.45425 0.000505412 1.12078 0.138966C0.7873 0.277427 0.502612 0.51206 0.303009 0.812952C0.103406 1.11384 -0.00206905 1.46736 3.07527e-05 1.82843V58.1821C3.07527e-05 58.6642 0.191555 59.1266 0.53247 59.4675C0.873385 59.8084 1.33576 60 1.81789 60H58.4624C58.8235 60.0021 59.177 59.8966 59.4779 59.697C59.7788 59.4974 60.0134 59.2127 60.1519 58.8792C60.2904 58.5457 60.3264 58.1786 60.2553 57.8246C60.1843 57.4705 60.0095 57.1457 59.7531 56.8914Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9931 52.7243H47.2646C48.2288 52.7243 49.1536 52.3412 49.8354 51.6594C50.5173 50.9776 50.9003 50.0528 50.9003 49.0886V14.0039L46.7192 6.31431C46.3959 5.75408 45.9289 5.29027 45.3665 4.97071C44.8041 4.65116 44.1666 4.48744 43.5198 4.49645C42.8584 4.50169 42.2109 4.68729 41.6471 5.03325C41.0833 5.3792 40.6246 5.8724 40.3204 6.45974L36.3574 14.0402V49.0886C36.3574 50.0528 36.7405 50.9776 37.4223 51.6594C38.1041 52.3412 39.0289 52.7243 39.9931 52.7243ZM39.9931 14.9128L43.5198 8.05945L47.2646 14.931V41.8171H39.9931V14.9128ZM39.9931 44.7802H47.2646V49.2158H39.9931V44.7802Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4);
export default __webpack_public_path__ + "static/media/service4.c7eb43cd04d5b2bb47986d015560de51.svg";
export { ForwardRef as ReactComponent };